/* eslint-disable array-callback-return */
/* eslint-disable arrow-parens */
// import * as utils from '@/utils/utils';

import services from '../services/common.js'
import { message } from 'antd'

const { getFileToken } = services

const namespace = 'common'

export default {
  namespace,
  state: {},

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *changeState({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 获取文件token
    *getFileToken({ payload, callback }, { call, put }) {
      const res = yield call(getFileToken, { ...payload })
      if (res.success) {
        callback && callback(res.data)
      } else {
        message.error(res.globalError)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
